import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
interface HeaderProps {
  name: string;
}

const Header: React.FC<HeaderProps> = ({ name }) => {
  const { t } = useTranslation("common");
  return (
    <Box
      borderRadius="12px"
      p="2px"
      background="linear-gradient(93.11deg, #6648FF 1.05%, #3EABC0 29.34%)"
    >
      <Box borderRadius="10px" padding="24px" background="white">
        <Box>
          <Text
            bgGradient="linear(to-r, #6648FF, #3EABC0)"
            bgClip="text"
            fontSize="30px"
            fontWeight="extrabold"
          >
            {t("reportCard.welcomeBack", { name })}
          </Text>

          <Text>{t("dashboard.subtext")}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
